import { FormRows } from '@acorns/web-components'
import { object } from 'yup'

import states from 'utils/states'
import submittableInfoSchema, {
  paritalSchema,
} from 'utils/validation-schemas/submittable-info'

export const validationSchema = object().concat(submittableInfoSchema)

export function getValidationSchema(props) {
  if (props && props.switchType === 'submittable' && !props.requireAddress) {
    return paritalSchema
  }
  return validationSchema
}
export const employerInfoRows = (): FormRows => [
  [
    {
      label: 'Name of Employer *',
      name: 'name',
      type: 'text',
      locked: true,
      sizes: { sm: 12, md: 12, xs: 12 },
      placeholder: 'Name',
    },
  ],
]

export const submittableInfoRows = (): FormRows => [
  [
    {
      label: 'Address *',
      name: 'address1',
      type: 'text',
      placeholder: '123 Street',
    },
    {
      label: 'Address (Line 2)',
      name: 'address2',
      type: 'text',
      placeholder: 'Apt #123',
    },
  ],
  [
    {
      label: 'City *',
      name: 'city',
      type: 'text',
      placeholder: 'Irvine',
    },
    {
      label: 'State *',
      name: 'state',
      options: states,
      type: 'select',
    },
  ],
  [
    {
      label: 'Zip *',
      name: 'zip',
      type: 'text',
      placeholder: '92610',
    },
  ],
]
